// extracted by mini-css-extract-plugin
export default {"rotateArrow":"rotateArrow___bmzWs","rotate-arrow":"rotate-arrow___ecTPN","base":"base___UP3DZ"};